import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UserProfile, CreateUserInput, UpdateUserInput } from '@bom/shared';
import { api } from '../lib/apiClient';

/** 平台管理：使用者（皆需 platform_admin） */
export function useUsers(enabled = true) {
  return useQuery({
    queryKey: ['users'],
    queryFn: () => api.get<{ users: UserProfile[] }>('/users').then((r) => r.users),
    enabled,
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateUserInput) => api.post<{ id: string }>('/users', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { uid: string; body: UpdateUserInput }) =>
      api.patch<void>(`/users/${vars.uid}`, vars.body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useDisableUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uid: string) => api.post<void>(`/users/${uid}/disable`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useDeleteUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uid: string) => api.del<{ deleted: number }>(`/users/${uid}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (vars: { uid: string; new_password: string }) =>
      api.post<void>(`/users/${vars.uid}/reset-password`, { new_password: vars.new_password }),
  });
}
